import { HeadFC } from 'gatsby'

import Layout from '@src/components/Layout'
import Seo from '@src/components/Seo'
import CustomInstantSearch from '@src/components/CustomInstantSearch'
import Hits from '@src/components/Hits'
import AutocompleteOnSearchPage from '@src/components/AutocompleteOnSearchPage'

import * as style from './style.module.sass'

const SearchPage = () => {
  return (
    <Layout>
      <div className={style.wrapper}>
        <CustomInstantSearch>
          <div className={style.autocomplete}>
            <AutocompleteOnSearchPage />
          </div>
          <div className={style.hits}>
            <Hits />
          </div>
        </CustomInstantSearch>
      </div>
    </Layout>
  )
}

export const Head: HeadFC = ({ location }) => (
  <Seo pathName={location.pathname} title="Search" />
)

export default SearchPage
